/**
 * @file AddSalaryTypeForm.jsx
 * @description Presentational component for the Add Salary Type form.
 * Uses FormRenderer to dynamically generate form fields based on configuration.
 */

import React from "react";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormRenderer from "Common/Custom/FormRenderer";
import PropTypes from "prop-types";

const AddSalaryTypeForm = ({
    fields = {},
    values = {},
    handleChange = () => { },
    handleSubmit = () => { },
    loading = false,
    title = "Add Salary Type",
    errors = {},
}) => {

    /**
     * Configuration for select dropdowns or other choice-based fields.
     * salary_type defines the list of options for the 'salary_type' field.
     */
    const optionConfig = {
        salary_type: {
            list: [
                { value: "Allowance", label: "Allowance" },
                { value: "Deduction", label: "Deduction" }
            ],
            valueKey: "value",
            labelKey: "label"
        }
    };

    return (
        <PageBody
            card={true}
            onSubmit={handleSubmit}
            headerchildren={<HeadingOne>{title}</HeadingOne>}>

            {/* 
                FormRenderer handles the mapping of field definitions (from JSON) 
                to actual UI components (Inputs, Selects, etc.)
            */}
            <FormRenderer
                fields={fields.formdata || []}
                values={values}
                errors={errors}
                handleChange={handleChange}
                optionConfig={optionConfig}
            />

            {/* Reusable submit button component */}
            <FormSubmitButton
                label="Save Salary Type"
                loading={loading}
                colSize="auto"
            />
        </PageBody>
    );
};

AddSalaryTypeForm.propTypes = {
    fields: PropTypes.object,
    values: PropTypes.object,
    handleChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    loading: PropTypes.bool,
    title: PropTypes.string,
    errors: PropTypes.object,
};

AddSalaryTypeForm.defaultProps = {
    fields: {},
    values: {},
    handleChange: () => { },
    handleSubmit: () => { },
    loading: false,
    title: "Add Salary Type",
    errors: {},
};

export default AddSalaryTypeForm;

